module.exports = __webpack_public_path__ + "img/chat_ai_bg.5ae91d9e.png";